import { h } from "preact";

import {

    Box,
    Button,
    Grid,
    Paper,

    Typography,
} from "@mui/material";

import palette from "../../theme/palette";

export default function ConfirmedEmail({ mode }) {
    console.log("ConfirmedEmail", mode)
    return (
        <div style="padding: 20px;">

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper
                        //	style="margin-bottom: 40px; width: 100%;" 
                        style={{ marginBottom: "40px", backgroundColor: palette.greenAlert }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            p={1}
                            flexDirection="column"
                        >
                            <Box p={1} style="margin-bottom: 10px">
                                <Typography variant="h5">Félicitations</Typography>
                                <Typography variant="body1">Votre email est confirmé.</Typography>
                                <Typography style="margin-bottom: 10px;" variant="body1">Nous vous encourageons à compléter les informations indispensables pour profiter des fonctionnalités de Bkeys en tant {mode === "a" ? " qu'ambassadeur" : mode === "v" ? " que vendeur" : "qu'acquéreur"}.</Typography>
                                <Button variant="contained" onClick={() => { window.location.replace(mode === "a" ? "/devenir-ambassadeur/3" : mode === "v" ? "/devenir-vendeur/2" : "/dashboardp"); }}>Fermer</Button>
                            </Box>

                        </Box>
                    </Paper>

                </Grid>
            </Grid>
        </div>
    );
}
